import { PencilSquareIcon, EyeIcon,  } from '@heroicons/react/16/solid';
import  { useState, useEffect } from 'react';
import { getRequest, postRequest } from '../../utils/APICall';
import { Spin, message, Pagination, Modal, Input,  } from 'antd';
import UpdatePayslipForm from './payslipForm';
import { useNavigate } from 'react-router-dom';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
const PaySlipTable = () => {
  const [payslipData, setPayslipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [individualPayslipData, setIndividualPayslipData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [monthnum, setMonthNum] = useState("");
  const [passwordModalVisible, setPasswordModalVisible] = useState(true);
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  const pageSize = 15;
  const T_Head = [
    "S.NO", "Employee Name", "Cheque No", "Net Pay",
    "Month Name", "Year", "Action"
  ];

  const fetchPayslips = async (page = 1) => {
    if (!isAuthenticated) return; 
    setLoading(true);
     try {
      const res = await getRequest(`getallpayslip?page=${page}&limit=${pageSize}`);
      if (res.success) {
        setPayslipData(res?.data);
        setTotalRecords(res.totalRecords || res?.data?.length);
      } else {
        message.error(res.message || 'Failed to fetch payslips');
      }
    } catch (err) {
      console.error('Error fetching payslip data:', err);
      message.error('Error fetching payslip data');
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
   const alreadyVerified = localStorage.getItem("payslipPasswordVerified");
   if (alreadyVerified) {
     setIsAuthenticated(true);
     setPasswordModalVisible(false);
   }
 }, []); 
useEffect(() => {
  if (isAuthenticated) {
    fetchPayslips(currentPage);
  }
}, [currentPage, isAuthenticated]);


  const handlePaginationChange = (page) => {
    setCurrentPage(page);
  };

  // Fetch individual payslip and open modal for edit
  const fetchIndividualPayslip = async (month, year, empid) => {
    try {
      const res = await getRequest(`empPayslip?month=${month}&year=${year}&empid=${empid}`);
      if (res.success) {
        setIndividualPayslipData(res.data);
        setModalVisible(true);
      } else {
        message.warning('This payslip does not exist');
        setModalVisible(false);
      }
    } catch (error) {
      console.error('Error fetching individual payslip:', error);
      message.error('Failed to fetch individual payslip');
    }
  };

  // Handle password submission
  const handlePasswordSubmit = async () => {
    if (!password.trim()) {
      message.error('Enter password');
      return;
    }
    try {
      const res =await postRequest("PayslipPassword",{password})
      
      if (res?.success) {
        setIsAuthenticated(true);
        setPasswordModalVisible(false);
        localStorage.setItem("payslipPasswordVerified", "true");
        fetchPayslips(currentPage);
      } else {
        message.error('Incorrect password');
        setPasswordModalVisible(false);
        navigate('/');
      }
      setPassword("");
    } catch (error) {
      console.log(error)
    }
  };

  
  // Navigate to individual payslip page
  const handleSeeMore = (month, year, empid) => {
    if (month && year && empid) {
      navigate(`/payslip/individualpayslip?month=${month}&year=${year}&empid=${empid}`);
    } else {
      message.error('Missing required parameters for payslip');
    }
  };

  return (
    <div className="font-[sans-serif] overflow-x-auto relative">
      {/* Password Modal */}
      <Modal
        title="Enter Password to View Payslips"
        open={passwordModalVisible}
        onOk={handlePasswordSubmit}
        onCancel={() => {
          setPasswordModalVisible(false);
          navigate('/');
        }}
        okText="Submit"
        cancelText="Cancel"
      >
        <Input.Password
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2"
          onPressEnter={handlePasswordSubmit}
          iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        />
      </Modal>

      {/* Loading Spinner or No Data Message */}
      {isAuthenticated ? (
        loading ? (
          <div className="flex justify-center items-center p-10">
            <Spin size="large" />
          </div>
        ) : payslipData.length === 0 ? (
          <div className="flex justify-center items-center p-10">
            <p>No Basic Salary records found.</p>
          </div>
        ) : (
          <>
            {/* Payslip Table */}
            <table className="min-w-full bg-white">
              <thead className="bg-primaryPurple whitespace-nowrap">
                <tr>
                  {T_Head.map((item, index) => (
                    <th
                      key={index}
                      className="p-4 text-left text-sm md:text-lg font-bold text-white"
                    >
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="whitespace-nowrap">
                {payslipData?.map((item, index) => (
                  <tr className="even:bg-blue-50" key={item.ID || index}>
                    <td className="p-4 text-sm text-black">{(currentPage - 1) * pageSize + index + 1}</td>
                    <td className="p-4 text-sm text-black">{item?.FIRSTNAME || '-'}</td>
                    <td className="p-4 text-sm text-black">{item?.CHEQUENO || '-'}</td>
                    <td className="p-4 text-sm text-black">{item?.NET_PAY?.toLocaleString('en-US') || '0'}</td>
                    <td className="p-4 text-sm text-black">{item?.MONTH || '-'}</td>
                    <td className="p-4 text-sm text-black">{item?.YEAR || '-'}</td>
                    <td className="p-4 flex items-center gap-2">
                      {/* Edit Icon */}
                      <div
                        className="cursor-pointer bg-blue-100 p-1 rounded"
                        onClick={() => {
                          if (item?.MONTHNUM && item?.YEAR && item?.FKEMPID) {
                            setMonthNum(item.MONTHNUM);
                            fetchIndividualPayslip(item.MONTHNUM, item.YEAR, item.FKEMPID);
                          } else {
                            console.warn('Missing MONTHNUM, YEAR, or EMPID in item');
                          }
                        }}
                      >
                        <PencilSquareIcon className="h-6 w-6 text-blue-500" />
                      </div>

                      {/* See More Icon */}
                      <div
                        className="cursor-pointer bg-green-100 p-1 rounded"
                        onClick={() => handleSeeMore(item.MONTHNUM, item.YEAR, item.FKEMPID)}
                      >
                        <EyeIcon className="h-6 w-6 text-green-500" />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination */}
            <div className="flex justify-end my-4">
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={totalRecords}
                onChange={handlePaginationChange}
                showSizeChanger={false}
              />
            </div>

            {/* Edit Payslip Modal */}
            <UpdatePayslipForm
              editingData={individualPayslipData}
              monthnum={monthnum}
              visible={modalVisible}
              onCancel={() => setModalVisible(false)}
              onOk={() => setModalVisible(false)}
            />
          </>
        )
      ) : null}
    </div>
  );
};

export default PaySlipTable;